var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftNonIdealIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_5145_57593)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9102 24.4551C16.9102 22.5469 18.457 21 20.3652 21H59.4751C61.3833 21 62.9302 22.5469 62.9302 24.4551V76.5449C62.9302 78.4531 61.3833 80 59.4751 80H20.3652C18.457 80 16.9102 78.4531 16.9102 76.5449V24.4551Z",
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 28.7444C33.1055 28.2556 33.5017 27.8594 33.9905 27.8594H48.8146C49.3033 27.8594 49.6996 28.2556 49.6996 28.7444C49.6996 29.2331 49.3033 29.6294 48.8146 29.6294H33.9905C33.5017 29.6294 33.1055 29.2331 33.1055 28.7444Z",
    fill: "#AEB5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 33.76C33.1055 33.2712 33.5017 32.875 33.9905 32.875H58.1193C58.6081 32.875 59.0043 33.2712 59.0043 33.76C59.0043 34.2488 58.6081 34.645 58.1193 34.645H33.9905C33.5017 34.645 33.1055 34.2488 33.1055 33.76Z",
    fill: "#AEB5BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 29.5449C20.8379 27.6367 22.3848 26.0898 24.293 26.0898H25.9378C27.846 26.0898 29.3929 27.6367 29.3929 29.5449V31.1898C29.3929 33.098 27.846 34.6448 25.9378 34.6448H24.2929C22.3848 34.6448 20.8379 33.098 20.8379 31.1898V29.5449Z",
    fill: "#AEB5BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 42.1702C33.1055 41.6814 33.5017 41.2852 33.9905 41.2852H48.8146C49.3033 41.2852 49.6996 41.6814 49.6996 42.1702C49.6996 42.6589 49.3033 43.0552 48.8146 43.0552H33.9905C33.5017 43.0552 33.1055 42.6589 33.1055 42.1702Z",
    fill: "#AEB5BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 47.1819C33.1055 46.6931 33.5017 46.2969 33.9905 46.2969H58.1193C58.6081 46.2969 59.0043 46.6931 59.0043 47.1819C59.0043 47.6706 58.6081 48.0669 58.1193 48.0669H33.9905C33.5017 48.0669 33.1055 47.6706 33.1055 47.1819Z",
    fill: "#AEB5BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 42.9668C20.8379 41.0586 22.3848 39.5117 24.293 39.5117H25.9378C27.846 39.5117 29.3929 41.0586 29.3929 42.9668V44.6117C29.3929 46.5198 27.846 48.0667 25.9378 48.0667H24.2929C22.3848 48.0667 20.8379 46.5198 20.8379 44.6117V42.9668Z",
    fill: "#AEB5BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 55.5881C33.1055 55.0994 33.5017 54.7031 33.9905 54.7031H48.8146C49.3033 54.7031 49.6996 55.0994 49.6996 55.5881C49.6996 56.0769 49.3033 56.4731 48.8146 56.4731H33.9905C33.5017 56.4731 33.1055 56.0769 33.1055 55.5881Z",
    fill: "#AEB5BE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 60.6038C33.1055 60.115 33.5017 59.7188 33.9905 59.7188H58.1193C58.6081 59.7188 59.0043 60.115 59.0043 60.6038C59.0043 61.0925 58.6081 61.4888 58.1193 61.4888H33.9905C33.5017 61.4888 33.1055 61.0925 33.1055 60.6038Z",
    fill: "#AEB5BE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 56.3887C20.8379 54.4805 22.3848 52.9336 24.293 52.9336H25.9378C27.846 52.9336 29.3929 54.4805 29.3929 56.3887V58.0335C29.3929 59.9417 27.846 61.4886 25.9378 61.4886H24.2929C22.3848 61.4886 20.8379 59.9417 20.8379 58.0335V56.3887Z",
    fill: "#AEB5BE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 69.01C33.1055 68.5212 33.5017 68.125 33.9905 68.125H48.8146C49.3033 68.125 49.6996 68.5212 49.6996 69.01C49.6996 69.4988 49.3033 69.895 48.8146 69.895H33.9905C33.5017 69.895 33.1055 69.4988 33.1055 69.01Z",
    fill: "#AEB5BE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 74.0256C33.1055 73.5369 33.5017 73.1406 33.9905 73.1406H58.1193C58.6081 73.1406 59.0043 73.5369 59.0043 74.0256C59.0043 74.5144 58.6081 74.9106 58.1193 74.9106H33.9905C33.5017 74.9106 33.1055 74.5144 33.1055 74.0256Z",
    fill: "#AEB5BE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 69.8144C20.8379 67.9063 22.3848 66.3594 24.293 66.3594H25.9378C27.846 66.3594 29.3929 67.9063 29.3929 69.8144V71.4593C29.3929 73.3675 27.846 74.9144 25.9378 74.9144H24.2929C22.3848 74.9144 20.8379 73.3675 20.8379 71.4593V69.8144Z",
    fill: "#AEB5BE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5145_57593",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 7) rotate(66.1979) scale(79.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftNonIdealIcon);
export default __webpack_public_path__ + "static/media/draft_non_ideal_icon.f990240bc8a911148bb4c532218ea501.svg";
export { ForwardRef as ReactComponent };